<!--
 * @Version: 1.2
 * @Author: admin
 * @Description: app
 * @Date: 2022-06-23 14:44:39
 * @LastEditors: sky
 * @LastEditTime: 2022-09-15 11:37:18
-->
<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="['bayonetCharge']">
      <component :is="Component"/>
    </keep-alive>
  </router-view>
</template>

<script>

</script>

<style lang="less">
.info-modal-content {
  text-align: center !important;

}

/* 在你的全局样式文件中添加此 CSS */
.arco-message {
  top: 3vh !important;
  /* 使用 vh 单位来表示视口高度的百分比 */
}
</style>
